import {emptyGuid} from "../../../../../Utilities/commonUtilities";
import { BRAILLER_STATUS } from "../braillerCatalogItemConstants.js";

export const braillerInventoryItemModel = ({
                                               braillerInventoryId,
                                               braillerCatalogItemId,
                                               serialNumber = '',
                                               assetNumber = '',
                                               copyNumber ,
                                               shelfLocation = '',
                                               status = BRAILLER_STATUS.Available,
                                               lastCheckedOut ,
                                               dueDate ,
                                               notes = '',
                                               cost ,
                                               dateCreatedUtc ,
                                               dateModifiedUtc
                                              }: Record<string, any> = {}) => ({
    braillerInventoryId: braillerInventoryId || emptyGuid,
    braillerCatalogItemId,
    serialNumber,
    assetNumber,
    copyNumber,
    shelfLocation,
    status,
    lastCheckedOut,
    dueDate,
    notes,
    cost,
    dateCreatedUtc,
    dateModifiedUtc
});

export const emptyBraillerInventoryItemModel = braillerInventoryItemModel();


